export const DESKTOP_TAB_LABELS = [
  "Basic Detail",
  "Professional Detail",
  "Education Detail",
  "Experience Detail",
  "Salary Detail",
  "Leave Detail",
];

export const MOBILE_TAB_LABELS = ["Personal", "Career", "Compensation"];

/** Mobile tab index → desktop section indices */
export const MOBILE_TAB_SECTIONS = [
  [0, 1],
  [2, 3],
  [4, 5],
];

export const isSectionVisible = (sectionIndex, tabIndex, isMobile) =>
  isMobile
    ? MOBILE_TAB_SECTIONS[tabIndex]?.includes(sectionIndex) ?? false
    : tabIndex === sectionIndex;

/** Which desktop section index each mobile edit mode targets */
export const SECTION_EDIT_MAP = {
  basic: 0,
  education: 2,
  experience: 3,
  account: 4,
};

export const EDIT_SECTION_LABELS = {
  basic: "Basic Details",
  education: "Education",
  experience: "Experience",
  account: "Account Details",
};

/** On mobile, when editing show only the active section — hide sibling view blocks */
export const shouldRenderSection = (
  sectionIndex,
  tabIndex,
  isMobile,
  editingSection
) => {
  if (!isSectionVisible(sectionIndex, tabIndex, isMobile)) return false;
  if (!isMobile || !editingSection) return true;
  return SECTION_EDIT_MAP[editingSection] === sectionIndex;
};
